import React, { useState } from "react";
import ButtonComponent from "../generic/ButtonComponent";
import { syncAllInventory } from "../../api/rest/ebay";
import { notify } from "../../helpers/notificationHelpers";
import { parseEbayError } from "../../utils/ebay";

interface EbayResyncInventoryButtonProps {
  integration: string;
}

function EbayResyncInventoryButton(props: EbayResyncInventoryButtonProps) {
  const { integration } = props;
  const [isResyncing, setIsResyncing] = useState(false);

  const handleResyncClick = () => {
    setIsResyncing(true);
    syncAllInventory()
      .then(() => {
        notify.warn(
          "Synchronizing inventory for all products. This may take a few minutes"
        );
      })
      .catch((error: Error) => {
        const message = parseEbayError(error);
        if (message) {
          notify.error(message);
        } else {
          notify.error(
            "Failed to synchronize inventory. Please try again later."
          );
        }
      })
      .finally(() => setIsResyncing(false));
  };

  if (integration !== "ebay") return null;

  return (
    <>
      <ButtonComponent
        primary
        disabled={isResyncing}
        onClick={() => handleResyncClick()}
      >
        <i className="fas fa-box-open" />
        Synchronize Inventory
      </ButtonComponent>{" "}
    </>
  );
}

export default EbayResyncInventoryButton;
